module.exports = __webpack_public_path__ + "static/media/huging-dog.24ff81f7.jpg";